import { put, call } from 'redux-saga/effects';
import { createQadraSaga } from './shared';
import { apiFeesGet } from '../api/fee';
import { FEES_GET } from '../actions/types';

function* feesGet({ payload: { financialAdvisorId, clientId } }) {
  const { fees } = yield call(apiFeesGet, { financialAdvisorId, clientId });
  yield put({
    type: FEES_GET._SUCCESS,
    payload: { fees },
  });
}

const watchFeesGet = createQadraSaga(feesGet, {
  action: FEES_GET._REQUEST,
});

export default [watchFeesGet];
